var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1667,
    cy: 18.1667,
    r: 18.1667,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5488 18.0791C23.134 18.0791 22.7988 18.4152 22.7988 18.8291V24.8291C22.7988 25.2424 22.4628 25.5791 22.0489 25.5791H11.5488C11.1348 25.5791 10.7989 25.2424 10.7989 24.8291V14.3291C10.7989 13.9159 11.1348 13.5791 11.5488 13.5791H17.5489C17.9636 13.5791 18.2988 13.2431 18.2988 12.8292C18.2988 12.4152 17.9636 12.0791 17.5489 12.0791H11.5488C10.3083 12.0791 9.29883 13.0886 9.29883 14.3291V24.8291C9.29883 26.0697 10.3083 27.0791 11.5488 27.0791H22.0489C23.2894 27.0791 24.2989 26.0697 24.2989 24.8291V18.8291C24.2989 18.4144 23.9635 18.0791 23.5488 18.0791Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3307 17.3962C16.2786 17.4486 16.2429 17.5151 16.228 17.5874L15.6977 20.2395C15.673 20.3624 15.712 20.4892 15.8005 20.5784C15.8354 20.6132 15.8768 20.6408 15.9223 20.6596C15.9679 20.6784 16.0167 20.688 16.066 20.6879C16.0899 20.6879 16.1148 20.6857 16.1395 20.6805L18.7908 20.1503C18.8643 20.1352 18.931 20.1 18.9828 20.0474L24.9168 14.1134L22.2655 11.4623L16.3307 17.3962ZM26.7497 9.62854C26.0185 8.89726 24.829 8.89726 24.0984 9.62854L23.0605 10.6665L25.7117 13.3177L26.7497 12.2797C27.1037 11.9265 27.2987 11.4554 27.2987 10.9544C27.2987 10.4534 27.1037 9.98242 26.7497 9.62854Z",
    fill: "#818181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9.29883 9.04492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircleIcon);
export default __webpack_public_path__ + "static/media/editCircleIcon.ecc805eac2c0b4a654ae89578ec6c0f6.svg";
export { ForwardRef as ReactComponent };